import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const LOGOTYPE_BLOCK_RECEIVE = "LOGOTYPE_BLOCK_RECEIVE";
export const LOGOTYPE_BLOCK_ERROR = 'LOGOTYPE_BLOCK_ERROR';

export const fetchLogotypeModel = (id) => (dispatch) => {
    return get('/api/logotypeBlock/' + id)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: LOGOTYPE_BLOCK_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: LOGOTYPE_BLOCK_ERROR,
    payload: {
        error,
    },
})